var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "People_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 64 64"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".People_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "People_svg___x31__DESKTOP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People_svg__Homepage-BusyBot---OFFLINE-2",
    transform: "translate(-541 -58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People_svg__UI_x2F_DuplicatedScreens_x2F_Homepage",
    transform: "translate(-62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People_svg__BusyBotStatus",
    transform: "translate(62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People_svg__Group-12",
    transform: "translate(530 51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People_svg__Live"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People_svg__Icon-people",
    transform: "translate(11 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People_svg__Group-3",
    transform: "translate(2.52)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "People_svg__Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 15.9,
    y: 19,
    width: 11.6,
    height: 11.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 15.9,
    y: 19,
    width: 11.6,
    height: 11.5,
    id: "People_svg__mask-2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#People_svg__Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "People_svg__path-1_2_",
    className: "People_svg__st1",
    d: "M15.9 19h11.5v11.5H15.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "People_svg__Fill-1",
    d: "M21.6 19c-3.2 0-5.8 2.6-5.8 5.7s2.6 5.7 5.8 5.7c3.2 0 5.8-2.6 5.8-5.7S24.8 19 21.6 19",
    mask: "url(#People_svg__mask-2_2_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "People_svg__Fill-4",
    className: "People_svg__st1",
    d: "M24.2 33.1c2.8 0 5.5.4 7.8 1.2 1.8.6 3.3 1.5 4.3 2.5s1.5 2.1 1.5 3.5v2.2H10.6v-2.2c0-1.6.7-2.8 2-3.9s3.2-2 5.4-2.5c1.9-.6 4-.8 6.2-.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "People_svg__Fill-6",
    className: "People_svg__st1",
    d: "M40 33.1c2.1 0 4.2.3 6.1.8 2.1.6 4 1.4 5.2 2.5 1.2 1.1 1.9 2.3 1.9 3.9v2.2H39.8v-2.2c0-2-.8-3.7-2.1-5-.7-.7-1.5-1.3-2.4-1.8 1.5-.3 3.1-.5 4.7-.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "People_svg__Group-10",
    transform: "translate(7.74)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "People_svg__Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 26.2,
    y: 19,
    width: 11.5,
    height: 11.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 26.2,
    y: 19,
    width: 11.5,
    height: 11.5,
    id: "People_svg__mask-4_2_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#People_svg__Adobe_OpacityMaskFilter_1_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "People_svg__path-3_2_",
    className: "People_svg__st1",
    d: "M26.2 19h11.5v11.5H26.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "People_svg__Fill-8",
    d: "M31.9 19c-3.2 0-5.8 2.6-5.8 5.7s2.6 5.7 5.8 5.7 5.8-2.6 5.8-5.7-2.6-5.7-5.8-5.7",
    mask: "url(#People_svg__mask-4_2_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  })))))))))));
};
export default SvgPeople;